import React, { useState } from "react";
import { IconChevronDown } from "@tabler/icons-react";
import classNames from "classnames";
import { motion } from "framer-motion";
import { NavSectionConfig } from "../../types/navbar";
import { NavbarTheme, NAVBAR_THEMES } from "../../constants/themes";
import CrossAppLink from "../CrossAppLink/CrossAppLink";

type Props = {
  section: NavSectionConfig;
  mode: NavbarTheme;
  // Solo requeridos cuando la sección tiene megaMenu
  isOpen?: boolean;
  onToggle?: () => void;
};

const NavDropdown = ({ section, mode, isOpen, onToggle }: Props) => {
  const theme = NAVBAR_THEMES[mode];
  const hasMegaMenu = !!section.megaMenu;

  // Estado local solo para secciones sin megaMenu (dropdown simple tipo BurgerMenuDesktop)
  const [localOpen, setLocalOpen] = useState(false);
  const open = hasMegaMenu ? (isOpen ?? false) : localOpen;

  const handleClick = () => {
    if (hasMegaMenu) {
      onToggle?.();
    } else {
      onToggle?.(); // cierra el mega menu si está abierto
      setLocalOpen((s) => !s);
    }
  };

  return (
    <div className="relative" onMouseLeave={() => !hasMegaMenu && setLocalOpen(false)}>
      <motion.button
        onClick={handleClick}
        type="button"
        whileTap={{ scale: 0.96 }}
        transition={{ type: "spring", stiffness: 400, damping: 20 }}
        className={classNames(
          "flex items-center gap-1 px-3 py-2 rounded-lg transition-colors focus:outline-none",
          open ? "text-primary" : theme.text,
          "hover:text-primary",
        )}
      >
        <span className="!font-grotesk text-sm font-medium">
          {section.title}
        </span>
        <IconChevronDown
          size={14}
          className={classNames("transition-transform duration-200", open && "rotate-180")}
        />
      </motion.button>

      {!hasMegaMenu && localOpen && (
        // pt-2 crea el puente visual entre el botón y el dropdown sin romper el onMouseLeave
        <div className="absolute left-0 top-full pt-2 z-[60]">
          <div className={classNames(
            "w-[250px] rounded-2xl p-6",
            "shadow-[rgba(0,0,0,0.12)_0px_8px_30px_0px,rgba(0,0,0,0.06)_0px_2px_6px_0px]",
            theme.dropdownBg,
          )}>
            <ul className="flex flex-col gap-3">
              {section.links.map((item) => (
                <li key={item.link}>
                  <CrossAppLink
                    to={item.link}
                    onClick={() => setLocalOpen(false)}
                    className={classNames("text-sm hover:text-primary transition-colors", theme.dropdownSubText)}
                  >
                    {item.name}
                  </CrossAppLink>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default NavDropdown;
